import { FC } from "react"

interface AppInitLoaderProps {
  error?: string | null
}

export const AppInitLoader: FC<AppInitLoaderProps> = ({ error }) => {
  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center px-6">
          <div className="mb-6">
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 flex items-center justify-center">
              <svg
                className="w-8 h-8 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Erreur d'initialisation
          </h2>
          <p className="text-gray-600 mb-6 max-w-md">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
          >
            Réessayer
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <div className="text-center">
        {/* Animated logo/icon */}
        <div className="relative w-24 h-24 mx-auto mb-8">
          {/* Outer rotating ring */}
          <div className="absolute inset-0 rounded-full border-4 border-primary-200 animate-spin" 
               style={{ 
                 borderTopColor: 'transparent',
                 animationDuration: '1.5s'
               }} 
          />
          
          {/* Middle rotating ring */}
          <div className="absolute inset-2 rounded-full border-4 border-secondary-200 animate-spin" 
               style={{ 
                 borderTopColor: 'transparent',
                 animationDuration: '2s',
                 animationDirection: 'reverse'
               }} 
          />
          
          {/* Inner pulsing dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full animate-pulse" />
          </div>
        </div>

        {/* Loading text */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">
          Initialisation
        </h2>
        <p className="text-gray-600 animate-pulse">
          Chargement de votre espace...
        </p>

        {/* Animated dots */}
        <div className="flex justify-center gap-2 mt-6">
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" 
               style={{ animationDelay: '0ms' }} 
          />
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" 
               style={{ animationDelay: '150ms' }} 
          />
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce" 
               style={{ animationDelay: '300ms' }} 
          />
        </div>
      </div>
    </div>
  )
}
